import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "opModal" }
const _hoisted_2 = { class: "body" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = ["onUpdate:modelValue"]
const _hoisted_5 = { class: "form-group d-flex mt-3" }
const _hoisted_6 = { class: "form-group d-flex mt-3" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "form-group d-flex mt-3" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 0,
  class: "form-group mt-3"
}
const _hoisted_11 = ["placeholder", "onUpdate:modelValue"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "text-center mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_value = _resolveComponent("localized-value")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "boxTitle" }, " Configurazione campo aggiuntivo ", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[5] || (_cache[5] = _createElementVNode("label", null, "Etichetta", -1)),
        _createVNode(_component_localized_value, null, {
          default: _withCtx((slotData) => [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              "onUpdate:modelValue": ($event: any) => ((_ctx.config.label.values[slotData.selectedLanguage]) = $event)
            }, null, 8, _hoisted_4), [
              [_vModelText, _ctx.config.label.values[slotData.selectedLanguage]]
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          class: "form-control",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.config.required) = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.config.required]
        ]),
        _cache[6] || (_cache[6] = _createElementVNode("label", null, "Campo obbligatorio", -1))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          class: "form-control",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.config.isSelect) = $event)),
          disabled: _ctx.config.isMultiSelect
        }, null, 8, _hoisted_7), [
          [_vModelCheckbox, _ctx.config.isSelect]
        ]),
        _cache[7] || (_cache[7] = _createElementVNode("label", null, "Campo a risposta singola predefinita", -1))
      ]),
      _createElementVNode("div", _hoisted_8, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          class: "form-control",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.config.isMultiSelect) = $event)),
          disabled: _ctx.config.isSelect
        }, null, 8, _hoisted_9), [
          [_vModelCheckbox, _ctx.config.isMultiSelect]
        ]),
        _cache[8] || (_cache[8] = _createElementVNode("label", null, "Campo a risposta multipla predefinita", -1))
      ]),
      (_ctx.config.isMultiSelect || _ctx.config.isSelect)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("label", null, [
              _cache[9] || (_cache[9] = _createTextVNode("Risposte possibili ")),
              _createElementVNode("button", {
                class: "ms-2 btn btn-sm btn-success",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addRisposta && _ctx.addRisposta(...args)))
              }, "+")
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.config.options, (item, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "form-group mt-1 d-flex align-items-center",
                key: i
              }, [
                _createVNode(_component_localized_value, null, {
                  default: _withCtx((slotData) => [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-control",
                      type: "text",
                      placeholder: 'Risposta ' + (i + 1),
                      "onUpdate:modelValue": ($event: any) => ((_ctx.config.options[i].values[slotData.selectedLanguage]) = $event)
                    }, null, 8, _hoisted_11), [
                      [_vModelText, _ctx.config.options[i].values[slotData.selectedLanguage]]
                    ])
                  ]),
                  _: 2
                }, 1024),
                _createElementVNode("button", {
                  class: "btn btn-sm btn-danger ms-2",
                  onClick: ($event: any) => (_ctx.removeRiposta(i))
                }, "-", 8, _hoisted_12)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("button", {
          class: "btn btn-success",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('close')))
        }, "Chiudi")
      ])
    ])
  ]))
}